import { ServerConfig } from "src/index";

// tslint:disable no-string-literal
export const server: ServerConfig = {
    rootApi: document.querySelector('meta-contents-viewer-root[data-root-api]')?.getAttribute('data-root-api') || (window as any)['SERVER_ROOT_API'],
    rootAnnotationApi: document.querySelector('meta-contents-viewer-root[data-root-annotation-api]')?.getAttribute('data-root-annotation-api') || (window as any)['SERVER_ROOT_ANNOTATION_API'],
    chatServer: document.querySelector('meta-contents-viewer-root[data-chat-server]')?.getAttribute('data-chat-server') || (window as any)['CHAT_SERVER'],
};
